import React from "react";
import classNames from "classnames";
import styles from "./Button.module.css";

interface ButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  size?: "medium" | "large";
  disabled?: boolean;
  type?: "button" | "submit";
  href?: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  size = "medium",
  disabled = false,
  type = "button",
  href,
  onClick,
  className,
}) => {
  const buttonClassName = classNames(
    styles.button,
    styles[variant],
    styles[size],
    {
      [styles.disabled]: disabled,
    },
    className,
  );

  // If href is provided, render as anchor.
  if (href) {
    // TODO: For relative links, use `<Link>` from React Router.
    return (
      <a
        className={buttonClassName}
        href={href}
        onClick={onClick}
        aria-disabled={disabled}
      >
        {children}
      </a>
    );
  }

  // Otherwise render as button.
  return (
    <button
      className={buttonClassName}
      type={type}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
